exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".forgot-password__submit{white-space:pre-wrap}", "", {"version":3,"sources":["/home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/pack/src/spa/Components/Session/ForgotPasswordForm.less"],"names":[],"mappings":"AACE,yBACE,oBAAA,CAAA","file":"ForgotPasswordForm.less","sourcesContent":[".forgot-password {\n  &__submit {\n    white-space: pre-wrap;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/css-loader??ref--2-2!/home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/less-loader/dist/cjs.js??ref--2-3!./spa/Components/Session/ForgotPasswordForm.less
// module id = 1613
// module chunks = 5 9 15 49